import React, { useState } from 'react';
import styled from 'styled-components';
import AuthInputComponent from '../../components/AuthInputComponent';
import AuthLogo from '../../components/auth/AuthLogo';
import AccountService from '../../api/service/member/AccountService';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  width: 100%;
  max-width: 400px;
  padding: 40px 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;

  @media (max-width: 768px) {
    height: 90vh;
    width: 90%;
    border-radius: 0px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
`;

const FindIdForm = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
`;

const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  border: none;
  font-size: 16px;
  color: white;
  cursor: pointer;

  background-color: ${({ theme }) => theme.colors.mainColor};

  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverColor};
  }
`;

const FindPasswordPopup = ({ onClose }: { onClose: () => void }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const validateInputs = () => {
    const newErrors: { [key: string]: string } = {};

    if (!oldPassword) {
      newErrors.oldPassword = '현재 비밀번호를 입력해 주세요.';
    }

    if (!newPassword) {
      newErrors.newPassword = '새 비밀번호를 입력해 주세요.';
    } else if (newPassword.length < 8) {
      newErrors.newPassword = '비밀번호는 최소 8자 이상이어야 합니다.';
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = '새 비밀번호 확인을 입력해 주세요.';
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = '새 비밀번호가 일치하지 않습니다.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!validateInputs()) {
      return;
    }

    try {
      const requestData = {
        beforePassword: oldPassword,
        newPassword: newPassword,
      };

      await AccountService.resetPassword(requestData);
      alert('비밀번호가 성공적으로 변경되었습니다.');
      onClose(); // 팝업 닫기
    } catch (error) {
      console.error('비밀번호 변경 실패:', error);
      alert(error);
    }
  };

  return (
    <Overlay>
      <PopupContainer>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <AuthLogo />
        <Title>비밀번호 변경</Title>
        <FindIdForm>
          <Form onSubmit={handleSubmit}>
            <AuthInputComponent
              type="password"
              placeholder="현재 비밀번호를 입력해 주세요."
              value={oldPassword}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setOldPassword(e.target.value)
              }
            />
            {errors.oldPassword && (
              <p style={{ color: 'red' }}>{errors.oldPassword}</p>
            )}

            <AuthInputComponent
              type="password"
              placeholder="새 비밀번호를 입력해 주세요."
              value={newPassword}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setNewPassword(e.target.value)
              }
            />
            {errors.newPassword && (
              <p style={{ color: 'red' }}>{errors.newPassword}</p>
            )}

            <AuthInputComponent
              type="password"
              placeholder="새 비밀번호를 한 번 더 입력해 주세요."
              value={confirmPassword}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setConfirmPassword(e.target.value)
              }
            />
            {errors.confirmPassword && (
              <p style={{ color: 'red' }}>{errors.confirmPassword}</p>
            )}

            <Button type="submit">확인</Button>
          </Form>
        </FindIdForm>
      </PopupContainer>
    </Overlay>
  );
};

export default FindPasswordPopup;
